<div class="tickr-wrapper magictime {{theme}}" *ngIf="currentTickrData && tickr.isTickrVisible"
  [ngClass]="{'slideLeft':tickr.slideTickrLeft && !theme,
              'slideRight':tickr.slideTickrRight && !theme,
              'v6':vwo.quickDonate_fallback_p1_AB()==='v1' && userData?.lastorder,
              'v7':vwo.quickDonate_fr_AB() && this.variablesService?.pageName === 'campaign' && currency !== 'INR' && userData?.lastorder?.iso_currency === currency,
              'v8': vwo.quickDonate_fr_AB() && userData?.lastorder?.iso_currency === currency && this.variablesService?.pageName === 'campaign' && currency === 'INR'}">
  <div class="flex-center donor-data-container">
    <!-- percentage of user donation -->
    <div class="flex-center" *ngIf="currentTickrData.byLocation">
      <div class="donor-data">
        <b>{{ currentTickrData.name }} </b>
      </div>
    </div>
    <!-- When user is NOT anonymous -->
    <div class="flex-center" *ngIf="currentTickrData?.is_anonymous == 0">
      <div *ngIf="currentTickrData.donoravtar && currentTickrData.donoravtar?.cdn_path" class="image-container">
        <img loading="lazy" [attr.data-src]="currentTickrData.donoravtar?.cdn_path"
          class="img-responsive supporter_image" [alt]="currentTickrData?.name" />
      </div>
      <div class="initial_image" *ngIf="currentTickrData.donoravtar == null">
        <span class="image_initial">
          {{ getInitials( currentTickrData.name) }}
        </span>
      </div>
      <div class="donor-data">
        <b>{{ truncateString( currentTickrData.name, 15) }} </b>
        just {{currentTickrData?.sip?'signed up for monthly giving':'donated'}}
        <b class="donation-amount">
          <ng-container *ngTemplateOutlet="donationAmt; context: {currentTickrData: currentTickrData}"></ng-container>
        </b>
      </div>
    </div>
    <!-- When user is anonymous -->
    <div class="flex-center anon-donor-data-container donor-data-container" *ngIf="currentTickrData?.is_anonymous == 1">
      <div class="anon_image_area">
        <img loading="lazy" [attr.data-src]="anonymousImg" class="img-responsive supporter_image"
          [alt]="currentTickrData?.name" />
      </div>
      <div class="donor-data">
        A Ketto donor anonymously donated
        <b class="donation-amount">
          <ng-container *ngTemplateOutlet="donationAmt; context: {currentTickrData: currentTickrData}"></ng-container>
        </b>
      </div>
    </div>
    <div class="close-holder">
      <i class="icon-Close" (click)="onTickrClick($event, 'close')"></i>
      <b *ngIf="currentTickrData?.donated_amount_local" class="donation-amount">
        <ng-container *ngTemplateOutlet="donationAmt; context: {currentTickrData: currentTickrData}"></ng-container>
      </b>
    </div>
  </div>
</div>

<ng-template #donationAmt let-currentTickrData="currentTickrData">
  <span [innerHTML]="currentTickrData?.currencyIcon?.symbol | safeHtml"></span>
  <span>{{ currentTickrData?.donated_amount_local | inrFormat:currentTickrData?.currencyIcon.currency }}</span>
</ng-template>